import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import { NoteCard } from 'components/UserContentCards';
import NoteEditor from 'components/NoteEditor';

const LearningToolsNoteCard = forwardRef(
  (
    { className, isCollaborationContent = false, userContentItem, ...props },
    ref,
  ) => {
    const [isEditing, setIsEditing] = useState(false);

    const title = userContentItem.page?.label ? (
      <>
        Page <span className="noTranslate">{userContentItem.page.label}</span>
      </>
    ) : (
      ''
    );

    return (
      <>
        <NoteCard
          ref={ref}
          cardId={`note-card-${userContentItem.id}`}
          className={className}
          isCollaborationContent={isCollaborationContent}
          isLearningToolsMenu={true}
          onEdit={() => setIsEditing(true)}
          title={title}
          titleComponentForDeleteDialog="h4"
          userContentItem={userContentItem}
          {...props}
        />
        {isEditing && (
          <NoteEditor
            isLearningToolsMenu={true}
            note={userContentItem}
            onClose={() => {
              setIsEditing(false);
            }}
            onSave={async (properties) =>
              await userContentItem.change(properties).save()
            }
          />
        )}
      </>
    );
  },
);

LearningToolsNoteCard.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
};

export default LearningToolsNoteCard;
